import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f039f4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "personal-center-card personal-center-card--first" }
const _hoisted_2 = { class: "personal-center-card__leftBox" }
const _hoisted_3 = { class: "card-left-top" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static.wecity.qq.com/miying/user-tx-d8b0a9a679c8cb84461f34e050986694.png",
  alt: "",
  class: "personal-center-card__img"
}, null, -1))
const _hoisted_5 = { class: "personal-center-card__con" }
const _hoisted_6 = { class: "personal-center-card__title" }
const _hoisted_7 = { class: "personal-center-card__line" }
const _hoisted_8 = { class: "personal-center-card__line" }
const _hoisted_9 = { class: "personal-center-card__line" }
const _hoisted_10 = {
  key: 0,
  class: "personal-center-card__rightBox"
}
const _hoisted_11 = {
  key: 0,
  class: "personal-center-card__desc"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static.wecity.qq.com/miying/desc-icon-b8ce304f3116a02872d1bdb7e39d4713.png",
  alt: "",
  class: "personal-center-card__statucIcon"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "personal-center-card__txt" }, "请耐心等待审核，也可先创建队伍/加入队伍", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "personal-center-card__desc2"
}
const _hoisted_16 = { class: "card-desc__line" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static.wecity.qq.com/miying/desc-icon-red-ba6242dbc265ace84ab27af62510b39c.png",
  alt: "",
  class: "card-desc__icon"
}, null, -1))
const _hoisted_18 = { class: "card-desc__con" }
const _hoisted_19 = { class: "card-desc__subtitle" }
const _hoisted_20 = {
  key: 2,
  class: "personal-center-card__desc2"
}
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"card-desc__line\" data-v-3f039f4c><img src=\"https://static.wecity.qq.com/miying/desc-icon-green-697b5ce1666305ad6fdf87081f45b0ae.png\" alt=\"\" class=\"card-desc__icon\" data-v-3f039f4c><div class=\"card-desc__con\" data-v-3f039f4c><div class=\"card-desc__title\" data-v-3f039f4c>报名申请审核已通过</div><div class=\"card-desc__subtitle\" data-v-3f039f4c>您的报名申请已通过，请完善以下信息</div></div></div>", 1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "personal-center-card__rightBox"
}
const _hoisted_24 = { class: "personal-center-card__desc" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static.wecity.qq.com/miying/desc-icon-green-697b5ce1666305ad6fdf87081f45b0ae.png",
  alt: "",
  class: "card-desc__icon"
}, null, -1))
const _hoisted_26 = { class: "personal-center-card__txt" }
const _hoisted_27 = {
  key: 2,
  class: "personal-center-card__rightBox"
}
const _hoisted_28 = { class: "begin-box-top" }
const _hoisted_29 = { class: "begin-box-left" }
const _hoisted_30 = { class: "begin-box-leftwrap" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "begin-box-title" }, "得分排名：（初赛）", -1))
const _hoisted_32 = { class: "begin-box-left__header" }
const _hoisted_33 = ["href"]
const _hoisted_34 = {
  key: 0,
  class: "begin-box-leftwrap"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "begin-box-title" }, "得分排名：（复赛）", -1))
const _hoisted_36 = { class: "begin-box-left__header" }
const _hoisted_37 = ["href"]
const _hoisted_38 = {
  key: 0,
  class: "begin-box-rightBtn t-disabled",
  disabled: ""
}
const _hoisted_39 = /*#__PURE__*/_createTextVNode("开始比赛")
const _hoisted_40 = {
  key: 2,
  class: "begin-box-rightText"
}
const _hoisted_41 = /*#__PURE__*/_createTextVNode("代金券领取指南 ")
const _hoisted_42 = {
  key: 3,
  class: "personal-center-card__rightBox"
}
const _hoisted_43 = { class: "begin-box-top" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "begin-box-left" }, null, -1))
const _hoisted_45 = { class: "begin-box-right" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("开始比赛")
const _hoisted_47 = {
  key: 0,
  class: "begin-box-rightText"
}
const _hoisted_48 = /*#__PURE__*/_createTextVNode("代金券领取指南 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabPane = _resolveComponent("TabPane")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Link = _resolveComponent("Link")!
  const _component_SemiFailed = _resolveComponent("SemiFailed")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.userStatus?.PlatName), 1),
          _createElementVNode("div", _hoisted_7, "身份证号：" + _toDisplayString(_ctx.userStatus?.IdNo), 1),
          _createElementVNode("div", _hoisted_8, "邮箱：" + _toDisplayString(_ctx.userStatus?.Email), 1),
          _createElementVNode("div", _hoisted_9, "手机号：" + _toDisplayString(_ctx.userStatus?.Mobile), 1)
        ])
      ])
    ]),
    (!_ctx.userStatus?.hasRegisterCom && (_ctx.raceInfo?.hasModify || _ctx.raceInfo?.hasAdd))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_ctx.userStatus?.AuditState == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
            : _createCommentVNode("", true),
          (_ctx.userStatus?.AuditState == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", {
                      class: "card-desc__title",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToCenter && _ctx.goToCenter(...args)))
                    }, "报名申请审核不通过"),
                    _createElementVNode("div", _hoisted_19, " 您的报名信息审核未通过，请修改后重新提交。 " + _toDisplayString(_ctx.userStatus?.RejectReason ? `拒绝原因：${_ctx.userStatus?.RejectReason}` : ''), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  class: "card-desc__btn",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToCenter && _ctx.goToCenter(...args)))
                }, "修改报名信息")
              ]))
            : _createCommentVNode("", true),
          (_ctx.userStatus?.AuditState == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.userStatus?.hasRegisterCom && _ctx.raceInfo?.hasModify)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.preStartTime) + " 初赛开始", 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.userStatus?.hasRegisterCom && _ctx.raceInfo?.LifeCycle > 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createVNode(_component_Tabs, {
                  modelValue: _ctx.activeTab,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeTab) = $event)),
                  type: "card"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preChannels, (item, index) => {
                      return (_openBlock(), _createBlock(_component_TabPane, {
                        label: item.CharName,
                        name: `${index}`,
                        key: item.Id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_32, _toDisplayString(item?.Title), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preRanks[item.Id], (ch, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "begin-box-left__top",
                              key: i
                            }, [
                              _createElementVNode("div", null, _toDisplayString(_ctx.stepMap.get(ch.Step)) + " 排名：" + _toDisplayString(ch?.Order), 1),
                              _createElementVNode("div", null, "得分：" + _toDisplayString(ch?.Score), 1),
                              _createElementVNode("div", null, [
                                _createElementVNode("a", {
                                  class: "begin-box-more",
                                  href: `./rankDetail?step=${ch.Step}`,
                                  target: "_blank"
                                }, "查看详情", 8, _hoisted_33)
                              ])
                            ]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["label", "name"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (_ctx.teamInfo?.StepState > 2 && _ctx.raceInfo?.LifeCycle > 7)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _hoisted_35,
                    _createVNode(_component_Tabs, {
                      modelValue: _ctx.activeTabSemi,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeTabSemi) = $event)),
                      type: "card"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.semiChannels, (item, index) => {
                          return (_openBlock(), _createBlock(_component_TabPane, {
                            label: item.CharName,
                            name: `${index}`,
                            key: item.Id
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_36, _toDisplayString(item?.Title), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.semiRanks[item.Id], (ch, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "begin-box-left__top",
                                  key: i
                                }, [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.stepMap.get(ch.Step)) + " 排名：" + _toDisplayString(ch?.Order), 1),
                                  _createElementVNode("div", null, "得分：" + _toDisplayString(ch?.Score), 1),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("a", {
                                      class: "begin-box-more",
                                      href: `./rankDetail?step=${ch.Step}`,
                                      target: "_blank"
                                    }, "查看详情", 8, _hoisted_37)
                                  ])
                                ]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label", "name"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(['begin-box-right', _ctx.teamInfo?.StepState > 2 && _ctx.raceInfo?.LifeCycle > 7 ? 'align-semi' : ''])
            }, [
              (_ctx.isInContest)
                ? (_openBlock(), _createElementBlock("button", _hoisted_38, " 开始比赛 "))
                : _createCommentVNode("", true),
              (!_ctx.isInContest)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    class: "begin-box-rightBtn t-disabled",
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_39
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.raceInfo?.LifeCycle > 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createVNode(_component_Link, {
                      type: "primary",
                      href: "./userGuide?page=couponContent",
                      underline: false
                    }, {
                      default: _withCtx(() => [
                        _hoisted_41
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.userStatus?.hasRegisterCom && _ctx.raceInfo?.LifeCycle > 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_Button, {
                class: "begin-box-rightBtn t-disabled",
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_46
                ]),
                _: 1
              }),
              (_ctx.raceInfo?.LifeCycle > 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createVNode(_component_Link, {
                      type: "primary",
                      href: "./userGuide?page=couponContent",
                      underline: false
                    }, {
                      default: _withCtx(() => [
                        _hoisted_48
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.raceInfo?.LifeCycle > 7)
      ? (_openBlock(), _createBlock(_component_SemiFailed, {
          key: 4,
          stepState: _ctx.teamInfo?.StepState,
          step: _ctx.teamInfo?.Step,
          raceId: _ctx.raceInfo?.Id,
          curTime: _ctx.raceInfo?.CurTime,
          userStatus: _ctx.userStatus,
          raceChannels: _ctx.raceChannels,
          raceOrders: _ctx.teamInfo?.Orders
        }, null, 8, ["stepState", "step", "raceId", "curTime", "userStatus", "raceChannels", "raceOrders"]))
      : _createCommentVNode("", true)
  ]))
}